import CustomerSearch from 'pages/Dashboard/CustomerSearch'
import EquipmentAlertsCard from 'pages/Dashboard/EquipmentAlertsCard'
import SdaAlertsCard from 'pages/Dashboard/SdaAlertsCard'
import ServiceContractsCard from 'pages/Dashboard/ServiceContractsCard'
import ConnectionStatusCard from 'pages/Dashboard/ConnectionStatusCard'
import CriticalAndMajorAlertsMapCard from 'pages/Dashboard/CriticalAndMajorAlertsMapCard'
import CustomerAdoptionCard from 'pages/Dashboard/CustomerAdoptionCard'
import PinnedCustomersCard from './PinnedCustomersCard'
import PaywallAcceptModal from 'pages/Dashboard/PaywallAcceptModal'
import PaywallFailureModal from 'pages/Dashboard/PaywallFailureModal'

import useDealer from 'hooks/useDealer'

import { PageHeader, PageTitle, screenSize } from 'styles/shared'
import styled from 'styled-components'
import React, { useState } from 'react'
import useSearchParams from 'hooks/useSearchParams'

const Dashboard = ({hasPaywallError = false, hasPaywallAcceptance = false}) => {
  const { dealer, isDealerLoaded } = useDealer(0)
  const [displayPaywallAcceptModal, setDisplayPaywallAcceptModal] = useState(hasPaywallAcceptance)
  const [displayPaywallFailureModal, setDisplayPaywallFailureModal] = useState(hasPaywallError)
  const {
    criticalAlertCount,
    majorAlertCount,
    minorAlertCount,
    sdaMajorAlertCount,
    sdaMinorAlertCount,
    connectedCount,
    disconnectedCount,
    dirtyFilterCount,
    activeServiceContractCount,
    expiredServiceContractCount,
    nonServiceContractCount
  } = dealer
  const error = useSearchParams('error')

  const onClosePaywallAcceptCallback = () => {
    setDisplayPaywallAcceptModal(false)
  }

  const onClosePaywallFailureCallback = () => {
    setDisplayPaywallFailureModal(false)
  }

  return (
    <S.Container>
      <S.PageHeader>
        <PageTitle>Dashboard</PageTitle>

        <CustomerSearch />
      </S.PageHeader>

      <S.Body>
        <S.StatusCards>
          <EquipmentAlertsCard {...{ criticalAlertCount, majorAlertCount, minorAlertCount }} isLoaded={isDealerLoaded} />
          <SdaAlertsCard {...{ sdaMajorAlertCount, sdaMinorAlertCount, dirtyFilterCount }} isLoaded={isDealerLoaded} />
          <ServiceContractsCard {...{ activeServiceContractCount, expiredServiceContractCount, nonServiceContractCount }} isLoaded={isDealerLoaded} />
          <ConnectionStatusCard {...{ connectedCount, disconnectedCount }} isLoaded={isDealerLoaded} />
        </S.StatusCards>

        <PinnedCustomersCard />
        <CriticalAndMajorAlertsMapCard />
        <CustomerAdoptionCard />
      </S.Body>
      {displayPaywallAcceptModal && <PaywallAcceptModal closeCallback={onClosePaywallAcceptCallback} />}
      {displayPaywallFailureModal && <PaywallFailureModal dealerId={dealer.id} closeCallback={onClosePaywallFailureCallback} error={error} />}
    </S.Container>
  )
}

export default Dashboard

const gapWidth = '10px'

const S = {
  Container: styled.div`
    width: 100%;
  `,
  PageHeader: styled(PageHeader)`
    @media ${screenSize.small} {
      padding-top: 10px;
    }
  `,
  Body: styled.div`
    display: grid;
    grid-template-columns: 3fr 2fr;
    padding: ${gapWidth};
    gap: ${gapWidth};

    @media ${screenSize.large} {
      display: flex;
      flex-direction: column;
    }
  `,
  StatusCards: styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: ${gapWidth};
    width: 100%;

    @media ${screenSize.medium} {
      grid-template-columns: 1fr;
    }
  `
}
